import { ReactNode } from "react"

import { ModalLayout } from "layouts/ModalLayout"

import styles from "./index.module.scss"

interface AdminMessageActionDialogProps {
  title: string
  children: ReactNode
  confirmText: string
  onConfirm: () => void
  onCancel: () => void
  isFetching?: boolean
  isResult?: boolean
}

export const AdminMessageActionDialog = ({
  title,
  children,
  confirmText,
  onConfirm,
  onCancel,
  isFetching,
  isResult,
}: AdminMessageActionDialogProps) => (
  <ModalLayout
    width="460px"
    confirmButtonText={confirmText}
    confirmButtonColor={isResult ? "blue" : "tropicalCyan"}
    isFetching={isFetching}
    isWithoutFooter={isResult}
    onConfirm={isResult ? undefined : onConfirm}
    onCancel={isResult ? undefined : onCancel}
    buttonSize="auto"
    cancelButtonText="Cancel"
  >
    <div className={styles.actionDialog}>
      <div className={styles.actionDialogBody}>
        <h3>{title}</h3>
        {children}
      </div>
      {isResult && (
        <button className={styles.actionDialogClose} type="button" onClick={onCancel}>
          Close
        </button>
      )}
    </div>
  </ModalLayout>
)
